import React, { useEffect } from "react";
import "./PaymentEfficiency.css";
import { Container, Row, Col } from "react-bootstrap";
import { trackEvent, trackPageView } from "../../utils/tracking";

export default function PaymentEfficiency() {
  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/PaymentEfficacyMatrix",
      "jmf_payment-efficacy-matrixs"
    );
    // trackPageView(
    //   "http://localhost:710/PaymentEfficacyMatrix",
    //   "jmf_payment-efficacy-matrixs"
    // );

    trackEvent({
      category: "Static Page",
      action: "Payment Page Loaded",
      label: "jmf_payment-efficacy-matrixs",
      value: 1,
    });
  }, []);

  return (
    <>
      <div className="pem-outer-main">
        <Container>
          <Row>
            <Col>
           <nav aria-label="Breadcrumb">
              <ul className="navigator-arrow">
                <li>
                  <a href="/" aria-label="Home">
                    <i className="fa fa-home" aria-hidden="true"></i>
                    <span className="sr-only">Home</span>
                  </a>

                  <span
                    className="breadcrumb-separator"
                    aria-hidden="true"
                  >
                    <i className="fa fa-angle-right"></i>
                  </span>
                </li>

                <li aria-current="page">
                  Payment Efficacy Matrix
                </li>
              </ul>
            </nav>
            </Col>
          </Row>
        </Container>

      
      </div>
      <Container>
  <div class="pem-main">
    {(() => {
      const thStyle = { border: "1px solid black" };
      const thMultiLine = { ...thStyle, whiteSpace: "pre-line", lineHeight: "1.4" };

      const COL_HEADERS = [
        { label: "Sr. no.",                              style: thStyle },
        { label: "Payment Mode",                         style: thStyle },
        { label: "Bank Name",                            style: thStyle },
        { label: "Indicative Cut off\nTime",             style: thMultiLine },
        { label: "Day of Debit to\nInvestor's account",  style: thMultiLine },
        { label: "Day of Credit to Mutual\nFund account",style: thMultiLine, className: "bg-radium" },
        { label: "Day of Unit Allotment",                style: thStyle },
      ];

      const NET_BANKING_BANKS = [
        { bank: "HDFC Bank",           cutoff: "2.45 PM", debit: "T", credit: "T",   allot: "T"   },
        { bank: "ICICI Bank",          cutoff: "2.45 PM", debit: "T", credit: "T",   allot: "T"   },
        { bank: "Axis Bank",           cutoff: "2.45 PM", debit: "T", credit: "T",   allot: "T"   },
        { bank: "Kotak Bank",          cutoff: "2.45 PM", debit: "T", credit: "T",   allot: "T"   },
        { bank: "IDBI Bank",           cutoff: "2.45 PM", debit: "T", credit: "T",   allot: "T"   },
        { bank: "Yes Bank",            cutoff: "2.45 PM", debit: "T", credit: "T",   allot: "T"   },
        { bank: "State Bank of India", cutoff: "2.45 PM", debit: "T", credit: "T",   allot: "T"   },
        { bank: "IndusInd Bank",       cutoff: "2.45 PM", debit: "T", credit: "T",   allot: "T"   },
        { bank: "IDFC Bank",           cutoff: "2.45 PM", debit: "T", credit: "T",   allot: "T"   },
        { bank: "All Other Banks",     cutoff: "3.00 PM", debit: "T", credit: "T+1", allot: "T+1" },
      ];

      const ACC_TRANSFER_BANKS = [
        "HDFC Bank", "ICICI Bank", "Axis Bank", "Kotak Bank", "IDBI Bank",
        "Yes Bank", "State Bank of India", "IDFC Bank", "IndusInd Bank",
      ];

      const LUMPSUM_SIMPLE_ROWS = [
        { sr: 4, mode: "RTGS",        cutoff: "2.30 PM",   debit: "T",   credit: "T",   allot: "T"   },
        { sr: 5, mode: "NEFT",        cutoff: "2.30 PM",   debit: "T",   credit: "T",   allot: "T"   },
        { sr: 6, mode: "NACH Mandate",cutoff: "< 3.00 PM", debit: "T+1", credit: "T+1", allot: "T+2", className: "bg-yellow-lite" },
        { sr: 7, mode: "Cheque Mode", cutoff: "< 3.00 PM", debit: "T+2", credit: "T+2", allot: "T+3", className: "bg-yellow-dark" },
      ];

      const SIP_ROWS = [
        { sr: 1, mode: "NACH (Physical / E-NACH)", debit: "T", credit: "T+1", allot: "T+1" },
        { sr: 2, mode: "UPI Autopay",              debit: "T", credit: "T+1", allot: "T+1" },
        { sr: 3, mode: "Auto Debit",               debit: "T", credit: "T+1", allot: "T+1" },
        { sr: 4, mode: "Internet SIP (ISIP)",      debit: "T", credit: "T+1", allot: "T+1" },
      ];

      return (
        <>
          {/* ─── TABLE 1 : Annexure A1 ─────────────────────────── */}
          <table class="table pem-table">
            <thead>
              <tr>
                <th colSpan="7" style={{ ...thStyle, fontWeight: "bold", fontSize: "20px" }}>
                  Disclosure of payment options and their efficiency. (Unit Allotment Timelines)
                </th>
              </tr>
              <tr>
                <th colSpan="7" style={thStyle}>
                  Pursuant to SEBI circular no. SEBI/HO/IMD/DF2/CIR/P/2020/175 dated September 17,
                  2020 read with circular no. SEBI/HO/IMD/DF2/CIR/P/2020/253 dated December 31,
                  2020, effective from February 1, 2021, the applicable NAV in respect of purchase
                  of units of mutual fund scheme is subject to realization & availability of the
                  funds in the bank account of mutual fund before the applicable cut off timings,
                  irrespective of the amount of investment and transaction types.
                </th>
              </tr>
              <tr class="bg-yellow">  <th colSpan="7" style={thStyle}>ANNEXURE A 1</th> </tr>
              <tr class="bg-orange">  <th colSpan="7" style={thStyle}>Payment Modes and their efficiency in Normal circumstances</th> </tr>
              <tr class="bg-green">   <th colSpan="7" style={thStyle}>Lump Sum Transactions</th> </tr>
              <tr class="bg-blue py">
                {COL_HEADERS.map((col, i) => (
                  <th key={i} style={col.style} class={col.className || ""}>{col.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>

              {/* Row 1 – UPI / IMPS */}
              <tr>
                <td>1</td>
                <td>UPI / IMPS</td>
                <td class="text-left">All Banks</td>
                <td class="text-left pl-10">2.45 PM</td>
                <td>T</td><td>T</td><td>T</td>
              </tr>

              {/* Row 2 – Net Banking */}
              {NET_BANKING_BANKS.map((r, i) => (
                <tr key={r.bank}>
                  {i === 0 && <td rowSpan="10">2</td>}
                  {i === 0 && <td rowSpan="10">Net Banking</td>}
                  <td class="text-left">{r.bank}</td>
                  <td class="text-left pl-10">{r.cutoff}</td>
                  <td>{r.debit}</td>
                  <td>{r.credit}</td>
                  <td>{r.allot}</td>
                </tr>
              ))}

              {/* Row 3 – A/c to A/c Transfer */}
              {ACC_TRANSFER_BANKS.map((bank, i) => (
                <tr key={bank}>
                  {i === 0 && <td rowSpan="9">3</td>}
                  {i === 0 && (
                    <td rowSpan="9" style={{ whiteSpace: "pre-line", lineHeight: "1.4" }}>
                      {"A/c to A/c Transfer\n(Through NET/Cheque\nDeposit)"}
                    </td>
                  )}
                  <td class="text-left">{bank}</td>
                  {i === 0 && <td rowSpan="9" class="text-left pl-10">&lt; 3.00 PM</td>}
                  <td>T</td><td>T</td><td>T</td>
                </tr>
              ))}

              {/* Rows 4–7 – RTGS / NEFT / NACH / Cheque */}
              {LUMPSUM_SIMPLE_ROWS.map((r) => (
                <tr key={r.sr} class={r.className || ""}>
                  <td>{r.sr}</td>
                  <td>{r.mode}</td>
                  <td class="text-left">All Banks</td>
                  <td class="text-left pl-10">{r.cutoff}</td>
                  <td>{r.debit}</td>
                  <td>{r.credit}</td>
                  <td>{r.allot}</td>
                </tr>
              ))}

            </tbody>
          </table>

          {/* ─── TABLE 2 : Annexure A2 ─────────────────────────── */}
          <table class="table pem-table mgtop">
            <thead>
              <tr class="bg-yellow">  <th colSpan="7" style={thStyle}>ANNEXURE A 2</th> </tr>
              <tr class="bg-orange">  <th colSpan="7" class="text-center" style={thStyle}>Payment Modes and their efficiency - SIP Transactions</th> </tr>
              <tr class="bg-blue py">
                {COL_HEADERS.map((col, i) => (
                  <th key={i} style={col.style} class={col.className || ""}>{col.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>

              {SIP_ROWS.map((r) => (
                <tr key={r.sr}>
                  <td>{r.sr}</td>
                  <td colSpan="2">{r.mode}</td>
                  <td>All Banks</td>
                  <td>{r.debit}</td>
                  <td>{r.credit}</td>
                  <td>{r.allot}</td>
                </tr>
              ))}

              <tr>
                <td colSpan="7" class="text-left bg-none">
                  T = SIP date/ Date of transaction received before cut off time of respective Schemes
                </td>
              </tr>
              <tr>
                <td colSpan="7" class="text-left">
                  <p class="text-red">
                    <strong>Important Note:</strong> 1) Liquid/Overnight Funds : Unit allotment
                    will be subject to receipt of funds in the mutual fund account before the
                    applicable cut-off time (currently before 1.30 PM).
                  </p>
                  <p class="text-red">
                    2) Non-Liquid Funds : Unit allotment will be subject to receipt of funds in
                    the mutual fund account before the applicable cut-off time (Currently, 3:00 PM).
                    The table shows indicative unit allotment timeline based on payment mode.
                  </p>
                </td>
              </tr>

            </tbody>
          </table>
        </>
      );
    })()}
  </div>
</Container>
    </>
  );
}
